export const createDiscountsSlice = (set, get) => ({
  discounts: {
    applyingPromoCode: false,
    applyingGiftCard: false,
    promoCodeSuccess: false,
    giftCardSuccess: false,
    giftCardError: null,
    promoCodeError: null,
  },
  discountsActions: {
    setApplyingPromoCode: (applyingPromoCode) =>
      set((state) => { state.discounts.applyingPromoCode = applyingPromoCode }),

    setApplyingGiftCard: (applyingGiftCard) =>
      set((state) => { state.discounts.applyingGiftCard = applyingGiftCard }),

    setPromoCodeSuccess: (promoCodeSuccess) =>
      set((state) => { state.discounts.promoCodeSuccess = promoCodeSuccess }),

    setGiftCardSuccess: (giftCardSuccess) =>
      set((state) => { state.discounts.giftCardSuccess = giftCardSuccess }),

    setGiftCardError: (giftCardError) =>
      set((state) => { state.discounts.giftCardError = giftCardError }),

    setPromoCodeError: (promoCodeError) =>
      set((state) => { state.discounts.promoCodeError = promoCodeError }),
  }
});
